import { render, staticRenderFns } from "./UserView_Followers.vue?vue&type=template&id=485c2cc0&"
import script from "./UserView_Followers.vue?vue&type=script&lang=js&"
export * from "./UserView_Followers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports